import AddIcon from "@mui/icons-material/Add";
import ArrowForwardIos from "@mui/icons-material/ArrowForwardIos";
import {
  Box,
  Card,
  CardContent,
  Divider,
  IconButton,
  ImageList,
  ImageListItem,
  List,
  ListItem,
  ListItemText,
  Switch,
} from "@mui/material";
import { Typography } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { default as api, default as Api } from "../API/api";
import { loginState, WHState } from "../Atom/AtomState";
import AlertComponent from "../CommonComponent/Alert/AlertComponent";
import ButtonComponent from "../CommonComponent/Inputs/ButtonComponent";
import SelectComponent from "../CommonComponent/Inputs/SelectComponent";
import TextComponent from "../CommonComponent/Inputs/TextComponent";
import Loading from "../CommonComponent/LoadingBar/Loading";
import "../CSS/PageCSS/QuestionDetailPage.css";
import FileComponent from "../CommonComponent/Inputs/FileComponent";
import { filesList } from "../CommonComponent/CommonFunction";

const { Title } = Typography;

export default function QuestionDetailPage() {
  const location = useLocation();
  const key = location.state;
  let navigate = useNavigate();
  const LoginState = useRecoilValue(loginState);
  const WH = useRecoilValue(WHState);
  const [question, setQuestion] = useState<any>({
    p_id: 0,
    question: "",
    question_E: "",
    question_J: "",
    question_CS: "",
    question_CT: "",
    show_yn: 0,
    sort_order: 0,
    questiontype_id: 1,
    multi: 0,
  });
  const [questionTypeData, setQuestionTypeData] = useState<any>();
  const [divboxHeight, setdivBoxHeight] = useState<number>(0);
  const [menuList, setMenuList] = useState<any>([]);
  const [addmenu, setAddmenu] = useState<any>({
    question: "",
    question_E: "",
    question_J: "",
    question_CS: "",
    question_CT: "",
  });
  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [uploadedFiles, setUploadedFiles]: any[] = useState([]);
  const [deleteFiles, setDeleteFiles]: any[] = useState([]);

  const upload = (value: any) => {
    setUploadedFiles([...uploadedFiles, ...value]);
  };

  const onDelete = (index: any) => {
    setDeleteFiles([...deleteFiles, uploadedFiles[index]]);
    const updatedArray = [...uploadedFiles];
    updatedArray.splice(index, 1);
    setUploadedFiles(updatedArray);
  };

  const handleAddList = () => {
    if (
      addmenu.question == "" ||
      addmenu.question_E == "" ||
      addmenu.question_J == "" ||
      addmenu.question_CS == "" ||
      addmenu.question_CT == ""
    ) {
      setAlert(true);
      setAlertMessage("객관식 질문을 전체 채워주세요.");
    } else {
      setMenuList((oldArray: any) => [...oldArray, addmenu]);
      setAddmenu({
        question: "",
        question_E: "",
        question_J: "",
        question_CS: "",
        question_CT: "",
      });
    }
  };

  const changeTextField = (value: any) => {
    if (value.name == "question") {
      setQuestion((prev: any) => ({
        ...prev,
        question: value.value,
      }));
    } else if (value.name == "question_E") {
      setQuestion((prev: any) => ({
        ...prev,
        question_E: value.value,
      }));
    } else if (value.name == "question_J") {
      setQuestion((prev: any) => ({
        ...prev,
        question_J: value.value,
      }));
    } else if (value.name == "question_CS") {
      setQuestion((prev: any) => ({
        ...prev,
        question_CS: value.value,
      }));
    } else if (value.name == "question_CT") {
      setQuestion((prev: any) => ({
        ...prev,
        question_CT: value.value,
      }));
    } else if (value.name == "addmenu_question") {
      setAddmenu((prev: any) => ({
        ...prev,
        question: value.value,
      }));
    } else if (value.name == "addmenu_question_E") {
      setAddmenu((prev: any) => ({
        ...prev,
        question_E: value.value,
      }));
    } else if (value.name == "addmenu_question_J") {
      setAddmenu((prev: any) => ({
        ...prev,
        question_J: value.value,
      }));
    } else if (value.name == "addmenu_question_CS") {
      setAddmenu((prev: any) => ({
        ...prev,
        question_CS: value.value,
      }));
    } else if (value.name == "addmenu_question_CT") {
      setAddmenu((prev: any) => ({
        ...prev,
        question_CT: value.value,
      }));
    }
  };

  const changeSelect = (value: any) => {
    if (value.name == "questiontype_id") {
      setQuestion((prev: any) => ({
        ...prev,
        questiontype_id: value.value,
        multi: 0,
      }));
      setMenuList([]);
      setAddmenu({
        question: "",
        question_E: "",
        question_J: "",
        question_CS: "",
        question_CT: "",
      });
      setUploadedFiles([]);
      setDeleteFiles([]);
    }
  };

  const changeSwitch = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.name == "show_yn") {
      setQuestion((prev: any) => ({
        ...prev,
        show_yn: event.target.checked == true ? 1 : 0,
      }));
    } else if (event.target.name == "multi") {
      setQuestion((prev: any) => ({
        ...prev,
        multi: event.target.checked == true ? 1 : 0,
      }));
    }
  };

  const handleSave = () => {
    if (key.state == "register") {
      const getInsert = async () => {
        setLoading(true);
        const formData = new FormData();
        formData.append("question", question.question);
        formData.append("question_E", question.question_E);
        formData.append("question_J", question.question_J);
        formData.append("question_CS", question.question_CS);
        formData.append("question_CT", question.question_CT);
        formData.append("show_yn", question.show_yn);
        formData.append("questiontype_id", question.questiontype_id);
        formData.append("multi", question.multi);

        if (question.questiontype_id == 2) {
          formData.append("NumberQuestion", JSON.stringify(menuList));
        }

        if (question.questiontype_id == 3) {
          for (let i = 0; i < uploadedFiles.length; i++) {
            formData.append("files", uploadedFiles[i]);
          }
        }

        const register = await Api.postfile(
          `/Question/insertQuestion`,
          formData
        );
        setLoading(false);
        if (register != undefined) {
          navigate("/QuestionPage");
        } else {
          setAlert(true);
          setAlertMessage("질문 등록에 실패하였습니다.");
        }
      };

      if (
        question.question == "" ||
        question.question_E == "" ||
        question.question_J == "" ||
        question.question_CS == "" ||
        question.question_CT == "" ||
        question.questiontype_id == ""
      ) {
        setAlert(true);
        setAlertMessage("필수값을 채워주세요.");
      } else {
        if (question.questiontype_id == 2 && menuList.length == 0) {
          setAlert(true);
          setAlertMessage("필수값을 채워주세요.");
        } else {
          getInsert();
        }
      }
    } else if (key.state == "update") {
      const getUpdate = async () => {
        setLoading(true);
        const formData = new FormData();
        formData.append("p_id", question.p_id);
        formData.append("show_yn", question.show_yn);

        const updateData = await Api.put(`/Question/updateQuestion`, formData);
        setLoading(false);
        if (updateData != undefined) {
          navigate(0);
        } else {
          setAlert(true);
          setAlertMessage("질문 수정에 실패하였습니다.");
        }
      };
      getUpdate();
    }
  };

  useEffect(() => {
    if (!LoginState?.manager) {
      navigate("/");
    } else {
      if (key == null) {
        navigate("/NotFoundPage");
      } else {
        const getType = async () => {
          setLoading(true);
          const questiontype = await api.get(`/Question/getQuestionType`);
          setLoading(false);
          if (questiontype != undefined) {
            setQuestionTypeData(questiontype);
          } else {
            setAlert(true);
            setAlertMessage("데이터 조회에 실패하였습니다.");
          }
        };
        getType();
        if (key.state != "register") {
          const getData = async () => {
            setLoading(true);
            const question = await api.get(
              `/Question/getQuestionInfo?p_id=${key.p_id}`
            );
            setLoading(false);
            if (question != undefined) {
              setQuestion(question[0]);
              if (question[0].questiontype_id == 2) {
                setLoading(true);
                const numberQuestion = await api.get(
                  `/Question/getNumberQuestionList?p_id=${key.p_id}`
                );
                setLoading(false);
                if (numberQuestion != undefined) {
                  numberQuestion.map((item: any) => {
                    var menu = {
                      question: item.NumberQuestion,
                      question_E: item.NumberQuestion_E,
                      question_J: item.NumberQuestion_J,
                      question_CS: item.NumberQuestion_CS,
                      question_CT: item.NumberQuestion_CT,
                    };
                    setMenuList((oldArray: any) => [...oldArray, menu]);
                  });
                } else {
                  setAlert(true);
                  setAlertMessage("데이터 조회에 실패하였습니다.");
                }
              }
            } else {
              setAlert(true);
              setAlertMessage("데이터 조회에 실패하였습니다.");
            }
          };
          getData();
        }
      }
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const div = document.getElementById("divbox") as HTMLElement;
      const QuestionDetailControlDiv = document.getElementById(
        "QuestionDetailControlDiv"
      ) as HTMLElement;
      if (div && QuestionDetailControlDiv) {
        setdivBoxHeight(
          div.clientHeight - QuestionDetailControlDiv.clientHeight - 40
        );
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  return (
    <div style={{ height: WH.height - 160 }}>
      <Title level={2} className="QuestionDetailTitle">
        QuestionDetailPage
      </Title>
      <div id="divbox">
        <Card className="QuestionDetailCard">
          <CardContent
            className="QuestionDetailCardContent"
            sx={{
              height: divboxHeight,
            }}
          >
            <Box className="QuestionDetailForm">
              <Title level={4} className="QuestionDetailName">
                질문(한국어)
              </Title>
              {key && (key.state == "view" || key.state == "update") ? (
                <Title level={5} className="QuestionDetailName">
                  <ArrowForwardIos
                    fontSize="small"
                    className="QuestionAnswerIcon"
                  />
                  {question.question}
                </Title>
              ) : (
                <TextComponent
                  variant="standard"
                  value={question.question}
                  name="question"
                  fullWidth
                  onChange={changeTextField}
                />
              )}
            </Box>
            <Box className="QuestionDetailForm">
              <Title level={4} className="QuestionDetailName">
                질문(영어)
              </Title>
              {key && (key.state == "view" || key.state == "update") ? (
                <Title level={5} className="QuestionDetailName">
                  <ArrowForwardIos
                    fontSize="small"
                    className="QuestionAnswerIcon"
                  />
                  {question.question_E}
                </Title>
              ) : (
                <TextComponent
                  variant="standard"
                  value={question.question_E}
                  name="question_E"
                  fullWidth
                  onChange={changeTextField}
                />
              )}
            </Box>
            <Box className="QuestionDetailForm">
              <Title level={4} className="QuestionDetailName">
                질문(일본어)
              </Title>
              {key && (key.state == "view" || key.state == "update") ? (
                <Title level={5} className="QuestionDetailName">
                  <ArrowForwardIos
                    fontSize="small"
                    className="QuestionAnswerIcon"
                  />
                  {question.question_J}
                </Title>
              ) : (
                <TextComponent
                  variant="standard"
                  value={question.question_J}
                  name="question_J"
                  fullWidth
                  onChange={changeTextField}
                />
              )}
            </Box>
            <Box className="QuestionDetailForm">
              <Title level={4} className="QuestionDetailName">
                질문(중국어간체)
              </Title>
              {key && (key.state == "view" || key.state == "update") ? (
                <Title level={5} className="QuestionDetailName">
                  <ArrowForwardIos
                    fontSize="small"
                    className="QuestionAnswerIcon"
                  />
                  {question.question_CS}
                </Title>
              ) : (
                <TextComponent
                  variant="standard"
                  value={question.question_CS}
                  name="question_CS"
                  fullWidth
                  onChange={changeTextField}
                />
              )}
            </Box>
            <Box className="QuestionDetailForm">
              <Title level={4} className="QuestionDetailName">
                질문(중국어번체)
              </Title>
              {key && (key.state == "view" || key.state == "update") ? (
                <Title level={5} className="QuestionDetailName">
                  <ArrowForwardIos
                    fontSize="small"
                    className="QuestionAnswerIcon"
                  />
                  {question.question_CT}
                </Title>
              ) : (
                <TextComponent
                  variant="standard"
                  value={question.question_CT}
                  name="question_CT"
                  fullWidth
                  onChange={changeTextField}
                />
              )}
            </Box>
            <Box className="QuestionDetailForm">
              <Title level={4} className="QuestionDetailName">
                조회여부
              </Title>
              {key && key.state == "view" ? (
                <Title level={5} className="QuestionDetailName">
                  <ArrowForwardIos
                    fontSize="small"
                    className="QuestionAnswerIcon"
                  />
                  <Switch
                    checked={question.show_yn == 1 ? true : false}
                    name="show_yn"
                  />
                </Title>
              ) : (
                <Switch
                  checked={question.show_yn == 1 ? true : false}
                  required
                  name="show_yn"
                  onChange={changeSwitch}
                />
              )}
            </Box>
            <Box className="QuestionDetailForm">
              <Title level={4} className="QuestionDetailName">
                질문유형
              </Title>
              {key && (key.state == "view" || key.state == "update") ? (
                <Title level={5} className="QuestionDetailName">
                  <ArrowForwardIos
                    fontSize="small"
                    className="QuestionAnswerIcon"
                  />
                  {questionTypeData &&
                    questionTypeData.filter(
                      (item: any) => item.p_id == question.questiontype_id
                    )[0].type}
                </Title>
              ) : (
                <SelectComponent
                  variant="standard"
                  value={question.questiontype_id}
                  label={"질문유형"}
                  name="questiontype_id"
                  menulist={questionTypeData}
                  menuvalue="type"
                  fullWidth
                  onChange={changeSelect}
                />
              )}
            </Box>
            {question.questiontype_id == "2" && (
              <>
                <Box className="QuestionDetailForm">
                  <Title
                    level={4}
                    className="QuestionDetailName"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    중복여부
                  </Title>
                  {key && key.state == "view" ? (
                    <Title level={5} className="QuestionDetailName">
                      <ArrowForwardIos
                        fontSize="small"
                        className="QuestionAnswerIcon"
                      />
                      <Switch
                        checked={question.multi == 1 ? true : false}
                        name="multi"
                      />
                    </Title>
                  ) : (
                    <Switch
                      checked={question.multi == 1 ? true : false}
                      required
                      name="multi"
                      onChange={changeSwitch}
                    />
                  )}
                </Box>
                <Box className="QuestionDetailForm">
                  <Title
                    level={4}
                    className="QuestionDetailName"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    객관식 질문 리스트
                    {key && (key.state == "view" || key.state == "update") ? (
                      ""
                    ) : (
                      <ButtonComponent
                        fullWidth
                        variant="contained"
                        onClick={() => handleAddList()}
                        className="QuestionSaveButton"
                      >
                        객관식 추가
                      </ButtonComponent>
                    )}
                  </Title>
                  {key && (key.state == "view" || key.state == "update") ? (
                    <List>
                      {menuList &&
                        menuList.map((item: any, index: any) => {
                          return (
                            <>
                              <Title level={5} className="QuestionDetailName">
                                {index + 1}.
                              </Title>
                              <ListItem disablePadding key={`${index}_0`}>
                                <ListItemText
                                  primary={
                                    <>
                                      <Title
                                        level={5}
                                        className="QuestionDetailName"
                                      >
                                        한국어 : {item.question}
                                      </Title>
                                    </>
                                  }
                                />
                              </ListItem>
                              <ListItem disablePadding key={`${index}_1`}>
                                <ListItemText
                                  primary={
                                    <>
                                      <Title
                                        level={5}
                                        className="QuestionDetailName"
                                      >
                                        영어 : {item.question_E}
                                      </Title>
                                    </>
                                  }
                                />
                              </ListItem>
                              <ListItem disablePadding key={`${index}_2`}>
                                <ListItemText
                                  primary={
                                    <>
                                      <Title
                                        level={5}
                                        className="QuestionDetailName"
                                      >
                                        일본어 : {item.question_J}
                                      </Title>
                                    </>
                                  }
                                />
                              </ListItem>
                              <ListItem disablePadding key={`${index}_3`}>
                                <ListItemText
                                  primary={
                                    <>
                                      <Title
                                        level={5}
                                        className="QuestionDetailName"
                                      >
                                        중국어(간체) : {item.question_CS}
                                      </Title>
                                    </>
                                  }
                                />
                              </ListItem>
                              <ListItem disablePadding key={`${index}_4`}>
                                <ListItemText
                                  primary={
                                    <>
                                      <Title
                                        level={5}
                                        className="QuestionDetailName"
                                      >
                                        중국어(번체) : {item.question_CT}
                                      </Title>
                                    </>
                                  }
                                />
                              </ListItem>
                              <Divider />
                            </>
                          );
                        })}
                    </List>
                  ) : (
                    <>
                      <Box>
                        <Title level={5} className="QuestionDetailName">
                          객관식질문(한국어)
                        </Title>
                        <TextComponent
                          variant="standard"
                          value={addmenu.question}
                          name="addmenu_question"
                          fullWidth
                          onChange={changeTextField}
                        />
                        <Title level={5} className="QuestionDetailName">
                          객관식질문(영어)
                        </Title>
                        <TextComponent
                          variant="standard"
                          value={addmenu.question_E}
                          name="addmenu_question_E"
                          fullWidth
                          onChange={changeTextField}
                        />
                        <Title level={5} className="QuestionDetailName">
                          객관식질문(일본어)
                        </Title>
                        <TextComponent
                          variant="standard"
                          value={addmenu.question_J}
                          name="addmenu_question_J"
                          fullWidth
                          onChange={changeTextField}
                        />
                        <Title level={5} className="QuestionDetailName">
                          객관식질문(중국어간체)
                        </Title>
                        <TextComponent
                          variant="standard"
                          value={addmenu.question_CS}
                          name="addmenu_question_CS"
                          fullWidth
                          onChange={changeTextField}
                        />
                        <Title level={5} className="QuestionDetailName">
                          객관식질문(중국어번체)
                        </Title>
                        <TextComponent
                          variant="standard"
                          value={addmenu.question_CT}
                          name="addmenu_question_CT"
                          fullWidth
                          onChange={changeTextField}
                        />
                        <List>
                          {menuList &&
                            menuList.map((item: any, index: any) => {
                              return (
                                <>
                                  <Title
                                    level={5}
                                    className="QuestionDetailName"
                                  >
                                    {index + 1}.
                                  </Title>
                                  <ListItem disablePadding key={`${index}_0`}>
                                    <ListItemText
                                      primary={
                                        <>
                                          <Title
                                            level={5}
                                            className="QuestionDetailName"
                                          >
                                            한국어 : {item.question}
                                          </Title>
                                        </>
                                      }
                                    />
                                  </ListItem>
                                  <ListItem disablePadding key={`${index}_1`}>
                                    <ListItemText
                                      primary={
                                        <>
                                          <Title
                                            level={5}
                                            className="QuestionDetailName"
                                          >
                                            영어 : {item.question_E}
                                          </Title>
                                        </>
                                      }
                                    />
                                  </ListItem>
                                  <ListItem disablePadding key={`${index}_2`}>
                                    <ListItemText
                                      primary={
                                        <>
                                          <Title
                                            level={5}
                                            className="QuestionDetailName"
                                          >
                                            일본어 : {item.question_J}
                                          </Title>
                                        </>
                                      }
                                    />
                                  </ListItem>
                                  <ListItem disablePadding key={`${index}_3`}>
                                    <ListItemText
                                      primary={
                                        <>
                                          <Title
                                            level={5}
                                            className="QuestionDetailName"
                                          >
                                            중국어(간체) : {item.question_CS}
                                          </Title>
                                        </>
                                      }
                                    />
                                  </ListItem>
                                  <ListItem disablePadding key={`${index}_4`}>
                                    <ListItemText
                                      primary={
                                        <>
                                          <Title
                                            level={5}
                                            className="QuestionDetailName"
                                          >
                                            중국어(번체) : {item.question_CT}
                                          </Title>
                                        </>
                                      }
                                    />
                                  </ListItem>
                                  <Divider />
                                </>
                              );
                            })}
                        </List>
                      </Box>
                    </>
                  )}
                </Box>
              </>
            )}
            {question.questiontype_id == "3" && (
              <Box className="QuestionDetailForm">
                <Title
                  level={4}
                  className="QuestionDetailName"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  사진 예시
                </Title>
                {key && key.state == "view" ? (
                  <ImageList sx={{ width: "100%" }} cols={1} gap={2}>
                    {question.files
                      ? question.files.map((item: any, index: any) => (
                          <ImageListItem key={index}>
                            <img
                              srcSet={`${filesList(
                                item
                              )}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                              src={`${filesList(item)}?auto=format`}
                              loading="lazy"
                              style={{
                                width: "100%",
                                height: "300px",
                                objectFit: "contain",
                              }}
                            />
                          </ImageListItem>
                        ))
                      : ""}
                  </ImageList>
                ) : (
                  <div>
                    <FileComponent
                      value={uploadedFiles}
                      upload={upload}
                      onDelete={onDelete}
                      accept={{ "image/*": [] }}
                      maxFiles={2}
                    />
                  </div>
                )}
              </Box>
            )}
          </CardContent>
          <Box id="QuestionDetailControlDiv">
            {key && key.state != "view" && (
              <ButtonComponent
                fullWidth
                variant="contained"
                onClick={() => handleSave()}
                className="QuestionSaveButton"
              >
                저장
              </ButtonComponent>
            )}
            <ButtonComponent
              fullWidth
              variant="contained"
              onClick={() => {
                navigate("/QuestionPage");
              }}
              className="QuestionCancelButton"
            >
              취소
            </ButtonComponent>
          </Box>
        </Card>
      </div>
      {alert && (
        <AlertComponent value={alert} setValue={setAlert} info="error">
          {alertMessage}
        </AlertComponent>
      )}
      {loading && <Loading />}
    </div>
  );
}
